import { ApolloLink } from '@apollo/client';
import createContextHeadersLink from './links/createContextHeadersLink';
import createRestLink from './links/createRestLink';
import createMissingAnnotationLink from './links/createMissingAnnotationLink';
import createAbortNetworkFetchLink from './links/createAbortNetworkFetchLink';
import createComparisonV1ToV2Link from './links/createComparisonV1ToV2Link';
export default function createV1ApolloLink(unionObjectTypesMap, // eslint-disable-next-line camelcase
__DO_NOT_USE_shadowComparisonOperationsV1ToV2) {
    const queryEndpointsToBeRequestedWithPost = [
        '/ajax/payment_intents_with_legacy_charges'
    ];
    return ApolloLink.from([
        createComparisonV1ToV2Link(__DO_NOT_USE_shadowComparisonOperationsV1ToV2),
        createContextHeadersLink(),
        createAbortNetworkFetchLink(),
        createRestLink(unionObjectTypesMap, queryEndpointsToBeRequestedWithPost),
        createMissingAnnotationLink()
    ]);
}

//# sourceMappingURL=createV1ApolloLink.js.map